// extracted by mini-css-extract-plugin
module.exports = {"video":"VideoBackground_video__1goqe","fitContain":"VideoBackground_fitContain__xL2m2"};